const prefix = 'INVENTORY_ADJUSTMENT'

export const INVENTORY_ADJUSTMENT_PAGE_REQUEST = `${prefix}_PAGE_REQUEST`

export const INVENTORY_ADJUSTMENT_ADJUSTMENTS_REQUEST = `${prefix}_ADJUSTMENTS_REQUEST`

export const INVENTORY_ADJUSTMENT_INGREDIENT_ADJUSTMENT_REQUEST = `${prefix}_INGREDIENT_ADJUSTMENT_REQUEST`

export const INVENTORY_ADJUSTMENT_SET_OUTLETS = `${prefix}_SET_OUTLETS`

export const INVENTORY_ADJUSTMENT_SET_ADJUSTMENTS = `${prefix}_SET_ADJUSTMENTS`

export const INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENTS = `${prefix}_SET_INGREDIENT_ADJUSTMENTS`

export const INVENTORY_ADJUSTMENT_SUBMIT_FORM_CREATE = `${prefix}_SUBMIT_FORM_CREATE`

export const INVENTORY_ADJUSTMENT_ON_CHANGE_OUTLET_IDS = `${prefix}_ON_CHANGE_OUTLET_IDS`

export const INVENTORY_ADJUSTMENT_ON_CHANGE_DATE = `${prefix}_ON_CHANGE_DATE`

export const INVENTORY_ADJUSTMENT_ON_CHANGE_NAMESPACE = `${prefix}_ON_CHANGE_NAMESPACE`

export const INVENTORY_ADJUSTMENT_SET_CURRENT_PAGE = `${prefix}_SET_CURRENT_PAGE`

export const INVENTORY_ADJUSTMENT_SET_TOTAL_PAGE = `${prefix}_SET_TOTAL_PAGE`

export const INVENTORY_ADJUSTMENT_EXPORT_ADJUSTMENT = `${prefix}_EXPORT_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_EXPORT_INGREDIENT_ADJUSTMENT = `${prefix}_EXPORT_INGREDIENT_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_ON_CLICK_ROW = `${prefix}_ON_CLICK_ROW`

export const INVENTORY_ADJUSTMENT_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT = `${prefix}_ON_CLICK_ROW_INGREDIENT_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_ON_CLICK_DONE = `${prefix}_ON_CLICK_DONE`

export const INVENTORY_ADJUSTMENT_OPEN_RIGHT_COLUMN = `${prefix}_OPEN_RIGHT_COLUMN`

export const INVENTORY_ADJUSTMENT_CLOSE_RIGHT_COLUMN = `${prefix}_CLOSE_RIGHT_COLUMN`

export const INVENTORY_ADJUSTMENT_SET_ADJUSTMENT_DETAIL = `${prefix}_SET_ADJUSTMENT_DETAIL`

export const INVENTORY_ADJUSTMENT_SET_INGREDIENT_ADJUSTMENT_DETAIL = `${prefix}_SET_INGREDIENT_ADJUSTMENT_DETAIL`

export const INVENTORY_ADJUSTMENT_ON_CLICK_CREATE_ADJUSTMENT = `${prefix}_ON_CLICK_CREATE_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_SHOW_ADD_ITEMS_MODAL = `${prefix}_SHOW_ADD_ITEMS_MODAL`

export const INVENTORY_ADJUSTMENT_HIDE_ADD_ITEMS_MODAL = `${prefix}_HIDE_ADD_ITEMS_MODAL`

export const INVENTORY_ADJUSTMENT_ON_CLICK_ADD_ITEMS = `${prefix}_ON_CLICK_ADD_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_CANCEL_ADD_ITEMS = `${prefix}_ADD_ITEMS_CANCEL_ADD_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_CONFIRM_ADD_ITEMS = `${prefix}_ADD_ITEMS_CONFIRM_ADD_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_ITEMS_REQUEST = `${prefix}_ADD_ITEMS_GET_ITEMS_REQUEST`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_GET_INGREDIENTS_REQUEST = `${prefix}_ADD_ITEMS_GET_INGREDIENTS_REQUEST`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEMS = `${prefix}_ADD_ITEMS_SET_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_SELECTED_ID = `${prefix}_ADD_ITEMS_SET_SELECTED_ID`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_INGREDIENTS = `${prefix}_ADD_ITEMS_SET_INGREDIENTS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT = `${prefix}_ADD_ITEMS_SHOW_ALREADY_ADDED_ALERT`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT = `${prefix}_ADD_ITEMS_HIDE_ALREADY_ADDED_ALERT`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SHOW_LOADING = `${prefix}_ADD_ITEMS_SHOW_LOADING`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_HIDE_LOADING = `${prefix}_ADD_ITEMS_HIDE_LOADING`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_SEARCH_ITEMS = `${prefix}_ADD_ITEMS_ON_SEARCH_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_ON_CHANGE_ITEMS = `${prefix}_ADD_ITEMS_ON_CHANGE_ITEMS`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_CURRENT_PAGE = `${prefix}_ADD_ITEMS_SET_CURRENT_PAGE`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_TOTAL_PAGE = `${prefix}_ADD_ITEMS_SET_TOTAL_PAGE`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_KEYWORD = `${prefix}_ADD_ITEMS_SET_KEYWORD`

export const INVENTORY_ADJUSTMENT_ADJUSTMENT_DETAIL_PAGE = `${prefix}_ADJUSTMENT_DETAIL_PAGE`

export const INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CHANGE_OUTLET = `${prefix}_ADJUSTMENT_FORM_ON_CHANGE_OUTLET`

export const INVENTORY_ADJUSTMENT_ADJUSTMENT_FORM_ON_CLICK_CANCEL = `${prefix}_ADJUSTMENT_FORM_ON_CLICK_CANCEL`

export const INVENTORY_ADJUSTMENT_SHOW_CONFIRM_SUBMIT_MODAL = `${prefix}_SHOW_CONFIRM_SUBMIT_MODAL`

export const INVENTORY_ADJUSTMENT_HIDE_CONFIRM_SUBMIT_MODAL = `${prefix}_HIDE_CONFIRM_SUBMIT_MODAL`

export const INVENTORY_ADJUSTMENT_CONFIRM_SUBMIT = `${prefix}_CONFIRM_SUBMIT`

export const INVENTORY_ADJUSTMENT_SHOW_IMPORT_MODAL = `${prefix}_SHOW_IMPORT_MODAL`

export const INVENTORY_ADJUSTMENT_HIDE_IMPORT_MODAL = `${prefix}_HIDE_IMPORT_MODAL`

export const INVENTORY_ADJUSTMENT_ON_SUCCESS_IMPORT = `${prefix}_ON_SUCCESS_IMPORT`

export const INVENTORY_ADJUSTMENT_SET_SUMMARY_INVENTORY_ADJUSTMENT = `${prefix}_SET_SUMMARY_INVENTORY_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_SET_SUMMARY_INGREDIENT_ADJUSTMENT = `${prefix}_SET_SUMMARY_INGREDIENT_ADJUSTMENT`

export const INVENTORY_ADJUSTMENT_ADD_ITEMS_SET_ITEM_HAS_RECIPE = `${prefix}_ADD_ITEMS_SET_ITEM_HAS_RECIPE`



// WEBPACK FOOTER //
// ./app/actions/inventory/adjustment/constants.js